module.exports = __webpack_public_path__ + "img/昆山华丰旧机动车交易市场有限公司.fadc37a3.jpg";